/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import AOS from 'aos';

$(document).ready(() => {
  AOS.init();

  // Get CSS variables from root
  const root = getComputedStyle(document.body);

  // Get CSS breakpoints
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl');

  // Scroll to section with offset
  $('.mega-section__navigation li a').on('click', function () {
    const sectionTo = $(this).attr('href');
    const header = $('.header').height();
    const megaSectionNav = $('.mega-section__navigation-head').height();

    // Change offset based on device size
    if ($(window).width() <= mdBreakpoint.replace('px','')) {
      $('html,body').animate({
          scrollTop: $(sectionTo).offset().top - (header + megaSectionNav + 60)
      }, 500);
    } else {
      $('html,body').animate({
          scrollTop: $(sectionTo).offset().top - (header + 48)
      }, 500);
    }
  });

  // Close navbar on modal toggle
  $(".modal-toggle a[href^='#']").on('click', function(e){
    e.preventDefault();
    var href = $(this).attr('href');
    $(href).modal('toggle');
    $('.navbar-collapse').collapse('hide');
  });

  // Close navigation dropdown on item click
  $('.mega-section__navigation a').on('click', function(e){
    $('.mega-section__navigation .collapse').collapse('hide');
  });

  // Add fixed class on scroll for mobile mega section navigation
  $(window).on('scroll', function(){
    var offset = $('.mega-section').offset().top;
    var top = $(document).scrollTop();
    if(top >= offset){
      // this is where you should fix you menu
      $('.mega-section__navigation').addClass('-fixed'); // if you have a css class which fix the element.
    }else{
      // this is where you should unfix your menu
      $('.mega-section__navigation').removeClass('-fixed'); // if you have a css class which fix the element.
    }
  });
});

/*
 * Executed on page load with URL containing an anchor tag.
 */
$(() => {
  if($(location.href.split("#")[1])) {
    let target = $('#'+location.href.split("#")[1]);
    if (target.length) {
      $('html,body').animate({scrollTop: target.offset().top - 150}, 300);
      return false;
    }
  }
})
